import { FC } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Button } from 'components/core/button';
import HeadHYP2 from 'public/assets/img/buddies/Head-HYP-2.gif';
import PinkWink from 'public/assets/img/buddies/Pink-HYP-Wink-1X.gif';

import { LeadProgram, LeadProgramColor } from '../constants';

const ReferralConfirmationMedicaid: FC<{
  handleGoBack: () => void;
  program: LeadProgram;
}> = ({ handleGoBack, program }) => {
  return (
    <div className="flex mx-auto lg:w-[800px] w-full flex-col px-5 mb-10 lg:mb-0">
      <div className="flex items-center flex-col lg:flex-row">
        <div className="order-1 lg:order-last">
          {program === LeadProgram.ASP ? (
            <img
              src={PinkWink}
              className="h-28 w-28 lg:h-32 lg:w-36 rounded-full"
            />
          ) : (
            <img
              src={HeadHYP2}
              className="h-28 w-28 lg:h-32 lg:w-36 rounded-full"
              style={{
                backgroundColor: '#e6d5f1',
              }}
            />
          )}
        </div>
        <div className="flex flex-col w-full order-last lg:order-first mt-6 lg:mt-0 m-auto">
          <div className="w-full flex lg:justify-start justify-center">
            <Text
              variant="h3"
              style={{
                color: LeadProgramColor[program],
              }}
            >
              Thank you!
            </Text>
          </div>
          <Text variant="body-2" className="text-center lg:text-left">
            Your referral was received, but we unfortunately don't accept
            Medicaid at this time.
          </Text>
        </div>
      </div>
      <Text variant="body-4" className="mt-8">
        We will follow up with the referred individual/caregiver with next steps
        for qualification if they choose to proceed without Medicaid.
      </Text>
      <Text
        className="!inline pt-4 relative before:absolute before:h-1 before:w-8 before:bg-[#ffafb4] before:top-0 pt-4 mt-8"
        variant="body-4"
      >
        If you have questions or need additional assistance, call&nbsp;
        <a
          href="tel:(800) 516-0975"
          className="font-semibold cursor-pointer text-[#018847]"
        >
          (800) 516-0975
        </a>
        &nbsp; for support.
      </Text>
      <div className="my-5 mx-auto">
        <Button className="" onClick={handleGoBack}>
          Refer Another Patient
        </Button>
      </div>
    </div>
  );
};

export default ReferralConfirmationMedicaid;
